import bgBody from "./../../../assets/img/bg.png";
const Bg = () => {
  return (
    <div className='w-[100vw] h-[100vh] absolute opacity-60 dark:opacity-20 overflow-hidden'>
      <img id='bg' src={bgBody} alt='background' className='w-[100vw]' />
    </div>
  );
};
export default Bg;
